import { Expandable } from '../components/expandable';
import type { TagOption } from '../components/tags';
import { TagIconButton, TagImageButton, TagsGroup } from '../components/tags';
import { createFilter } from '../create-filter';
import { type FilterProps } from '../types';
import { arrayFilterMethods } from '../utils';

export type TagsControlProps<T = string> = FilterProps<
  T[],
  {
    options: TagOption<T>[];
  }
>;

export const TagsControl = createFilter(function UnboundTagsControl({
  options,
  filter
}: TagsControlProps) {
  const { hasSelectedValue, toggleSelectedValue } = arrayFilterMethods(filter);

  const withImages = options.some((option) => !!option.imageSrc);
  const TagComponent = withImages ? TagImageButton : TagIconButton;

  return (
    <Expandable
      items={options}
      limit={6}
      itemsContainer={TagsGroup}
      renderItem={(option) => (
        <TagComponent
          key={option.value}
          selected={hasSelectedValue(option.value)}
          onClick={() => toggleSelectedValue(option.value)}
          imageSrc={option.imageSrc}
          iconSrc={option.iconSrc}
        >
          {option.label}
        </TagComponent>
      )}
    />
  );
});
